export enum ScreenSizes {
  XS = 'xs', // eslint-disable-line
  SM = 'sm', // eslint-disable-line
  MD = 'md', // eslint-disable-line
  LG = 'lg', // eslint-disable-line
  XL = 'xl', // eslint-disable-line
  XXL = 'xxl', // eslint-disable-line
}

export default {
  XS: ScreenSizes.XS,
  SM: ScreenSizes.SM,
  MD: ScreenSizes.MD,
  LG: ScreenSizes.LG,
  XL: ScreenSizes.XL,
  XXL: ScreenSizes.XXL,
};
